import React, { useEffect, useState } from 'react';
import { PopUp } from 'cantarus-react-ui';
import ScalablePreview from '../ScalablePreview/ScalablePreview';
import { TemplateStrings as Strings } from '../../utils/config';
import { scaleScreenTypes } from '../../utils/helpers';

const TemplatePreviewPopUp = ({ show, compiledTemplate, togglePopUp }) => {

    const [previewScalingRate, setPreviewScalingRate] = useState(0);

    const updateScalingRate = () => {
        const previewElement = document.getElementById('StencilLivePreviewPopup');
        if (previewElement) {
            const scalingRate = previewElement.clientWidth / window.innerWidth;
            if (scalingRate !== previewScalingRate) {
                setPreviewScalingRate(scalingRate);
            }
        }
    }

    // Add screen resize listener on element mount
    useEffect(() => {
        window.addEventListener('resize', updateScalingRate);
        return () => {
            window.removeEventListener('resize', updateScalingRate);
        };
    }, [])

    useEffect(() => {
        updateScalingRate();
    }, [compiledTemplate, show, togglePopUp])

    return (
        <PopUp
            title={Strings.previewHeader}
            show={show}
            width="90%"
            togglePopUp={togglePopUp}
        >
            <ScalablePreview htmlToDisplay={compiledTemplate} scaleScreenType={scaleScreenTypes.DESKTOP} />
        </PopUp>
    )
}

export default TemplatePreviewPopUp;
